import axiosInstance from '../axios';
import { AxiosRequestConfig } from 'axios';
import { API_BASE_URL } from '../../constants';

export class AppConfigAPI {
  appConfigServiceRoute = `${API_BASE_URL}/app-config`;
  config: AxiosRequestConfig = {};

  constructor() {
    this.config = { withCredentials: true };
  }

  getLanguages = async () => {
    try {
      const result = await axiosInstance.get<any>(`${this.appConfigServiceRoute}/language`);
      return result.data.payload;
    } catch (e) {
      throw new Error('apiResponse.couldNotGetLanguages');
    }
  };
}
